<template>
  <div class="relative h-full w-full" :class="[styles.containerClass]">
    <!-- background desktop props  -->
    <RevIllustration
      v-if="styles.backgroundImage"
      :alt="styles.backgroundImage.alt"
      class="absolute hidden md:block"
      :class="backgroundImageClass"
      :fetchpriority
      :height="styles.backgroundImage.height"
      :src="styles.backgroundImage.src"
      :width="styles.backgroundImage.width"
    />

    <!-- background mobile props  -->
    <RevIllustration
      v-if="styles.backgroundImage"
      :alt="styles.backgroundImage.alt"
      class="absolute block md:hidden"
      :class="backgroundImageClass"
      :fetchpriority
      :height="styles.backgroundImage.heightMobile"
      :src="styles.backgroundImage.srcMobile"
      :width="styles.backgroundImage.widthMobile"
    />

    <!-- overlay -->
    <div
      v-if="styles.hasOverlay && displayOverlay"
      class="absolute"
      :class="[styles.overlayClass, overlayClass]"
    />

    <div
      class="text-static-default-hi relative flex flex-col items-center justify-center"
      :class="[styles.moodClass, containerClass]"
    >
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { tw } from '@backmarket/utils/string/tw'
import { RevIllustration } from '@ds/components/Illustration'

import type { BackgroundProps } from './Background.types'
import { getBackgroundStyles } from './Background.utils'

const {
  background,
  rounded,
  containerClass,
  customOverlayClass,
  customBackgroundImageClass,
  displayOverlay = true,
  fetchpriority = 'auto',
} = defineProps<
  BackgroundProps & {
    containerClass?: string
    customOverlayClass?: string
    customBackgroundImageClass?: string
    displayOverlay?: boolean
    fetchpriority?: 'high' | 'low' | 'auto'
  }
>()

const styles = computed(() => getBackgroundStyles({ background, rounded }))

const overlayClass = computed(() => {
  if (customOverlayClass) return customOverlayClass

  return tw`bg-surface-default-low bottom-0 left-0 right-0 top-0 opacity-40`
})

const backgroundImageClass = computed(() => {
  if (customBackgroundImageClass) return customBackgroundImageClass

  return tw`!object-cover !object-center !inset-0 !h-full !w-full`
})
</script>
